"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouterState = void 0;
const history_1 = require("history");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
function useRouterState(key, defaultValue, opts = {}) {
    const location = react_router_dom_1.useLocation();
    const history = react_router_dom_1.useHistory();
    const params = react_1.useMemo(() => new URLSearchParams(location.search), [location.search]);
    function getState() {
        if (params.has(key)) {
            const stringValue = params.get(key);
            if (stringValue === null) {
                return defaultValue;
            }
            try {
                return JSON.parse(opts.encode === 'base64' ? atob(stringValue) : stringValue);
            }
            catch (_a) { }
        }
        return defaultValue;
    }
    const setRouterState = react_1.useCallback((value, options = {}) => {
        const stringified = JSON.stringify(value);
        params.set(key, opts.encode === 'base64' ? btoa(stringified) : stringified);
        if (value === defaultValue) {
            params.delete(key);
        }
        const newPath = history_1.createPath(Object.assign(Object.assign({}, location), { search: params.toString() }));
        if (options.replace) {
            history.replace(newPath);
        }
        else {
            history.push(newPath);
        }
    }, [params, defaultValue, history, key, location, opts.encode]);
    const lastState = react_1.useRef(getState());
    const state = getState();
    if (!lodash_1.isEqual(state, lastState.current)) {
        lastState.current = state;
    }
    return [lastState.current, setRouterState];
}
exports.useRouterState = useRouterState;
//# sourceMappingURL=useRouterState.js.map